import { render } from "./InputGhgEmission.vue?vue&type=template&id=61710320&scoped=true"
import script from "./InputGhgEmission.vue?vue&type=script&lang=ts"
export * from "./InputGhgEmission.vue?vue&type=script&lang=ts"

import "./InputGhgEmission.vue?vue&type=style&index=0&id=61710320&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61710320"

export default script